import styled from "styled-components";
import { MileagePopupWrapper } from "../../../style";

export const MileageBuyWrapper = styled(MileagePopupWrapper)`
  width: 514px;
  z-index: 1001;
  min-height: 322px;
`;

export const MileageMenuListWrapper = styled.div`
  border-radius: 15px;
  padding-top: 20px;
  padding-right: 15px;
  padding-bottom: 20px;
  padding-left: 15px;
  background: #f0f0f0;
  display: flex;
  flex-direction: column;
  gap: 13px;
  margin-top: 20px;
  height: 245px;
  justify-content: space-between;

  > .item-wrapper {
    display: flex;
    align-content: flex-start;
    flex-wrap: wrap;
    gap: 10px 27px;
    height: 210px;

    > .item {
      padding: 4.5px 17px;
      box-sizing: border-box;
      width: 133px;
      height: 34px;
      border-radius: 9.78px;
      background: #ffffff;
      cursor: pointer;

      > .name {
        font-family: Pretendard;
        font-weight: 700;
        font-size: 11px;
        text-align: center;
        white-space: nowrap;
      }

      > .price {
        font-family: Pretendard;
        font-weight: 500;
        font-size: 10px;
        text-align: center;
      }
    }
  }
`;

export const MileageMenuManage = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -385px; /* height / 2 */
  margin-left: -530px; /* width / 2 */
  z-index: 1003;
  width: 1060px;
  height: 770px;
  background: #fff;
  border-radius: 13px;
  padding: 40px 15px;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  gap: 30px;
`;

export const MileageMenuBodyWrapper = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
  gap: 30px;
  transform: none;
`;

export const MenuBottomWrapper = styled.div`
  width: 100%;
  height: 59px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 80px;

  > .button {
    width: 176px;
    height: 50px;
    padding: 10px 12px;
    box-sizing: border-box;
    border-radius: 30.35px;

    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    text-align: center;
    font-family: Pretendard;
    font-size: 20.233px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    &.purple {
      width: 584px;
      height: 59px;
      color: #fff;
      background: #7f25fb;
    }

    &.gray {
      color: #b3b3b3;
    }
  }
`;

export const MenuListWrapper = styled.div`
  width: calc(523px - 60px);
  height: calc(100% - 60px);
  max-height: 500px;
  display: flex;
  flex-direction: column;
  gap: 5.73px;
  border-radius: 4.586px;
  background: #f0f0f0;
  padding: 30px;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const MenuItem = styled.div`
  width: calc(100% - 22px);
  height: 32px;
  padding: 4px 11px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  border-radius: 11.466px;
  background: #fff;

  color: #121212;
  font-family: Pretendard;
  font-size: 11.466px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  user-select: none;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }

  &.selected {
    background: #e6f3ff;
  }

  > img {
    cursor: pointer;
    flex-shrink: 0;
  }

  > .name {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const MenuManageWrapper = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
`;

export const MenuInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const MenuInputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const MenuInputLabel = styled.div`
  font-family: Pretendard;
  font-weight: 500;
  font-size: 14px;
  color: #121212;
  min-width: 100px;
`;

export const MenuInput = styled.input`
  flex: 1;
  height: 34px;
  border-radius: 9.78px;
  outline: none;
  border: 1px solid #e5e5e5;
  background: #f0f0f0;
  box-sizing: border-box;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 14.67px;
  text-align: center;
  padding: 0 10px;

  &::placeholder {
    font-size: 12px;
  }
`;

export const MenuImageDropZoneWrapper = styled.div`
  border-radius: 15px;
  border: 5px dashed #bebebe;
  flex: 1;

  opacity: 0.8;
  background: #f0f3f8;
`;

export const MileageMenuManageListWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 8px;

  > input {
    height: 34px;
    border-radius: 9.78px;
    outline: none;
    border: 1px solid #e5e5e5;
    background: #f0f0f0;
    box-sizing: border-box;
    font-family: Pretendard;
    font-weight: 500;
    font-size: 14.67px;
    text-align: center;
  }

  > .edit-input {
    background: #fff;
  }

  > .name {
    width: 179px;
  }
  > .price {
    width: 109px;
  }

  > .edit {
    border-radius: 9.78px;
    width: 51px;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 12px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    background: #f0f0f0;
    cursor: pointer;

    &.purple {
      background: #6436e7;
      color: #fff;
    }
  }

  > img {
    cursor: pointer;
    width: 16px;
    height: 16px;
  }
`;

export const MileageMenuManageWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 8px;

  > input {
    height: 34px;
    border-radius: 9.78px;
    outline: none;
    border: 1px solid #e5e5e5;
    background: #f0f0f0;
    box-sizing: border-box;
    font-family: Pretendard;
    font-weight: 500;
    font-size: 14.67px;
    text-align: center;
  }

  > input::placeholder {
    font-size: 12px;
  }

  > .edit-input {
    background: #fff;
  }

  > .name {
    width: 179px;
  }
  > .price {
    width: 168px;
  }

  > img {
    cursor: pointer;
    width: 16px;
    height: 16px;
  }
`;

export const MileageBuyListWrapper = styled.div`
  width: 100%;
  height: 227px;
  border-radius: 15px;
  background: #f0f0f0;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  padding: 20px 23px 30px;
  box-sizing: border-box;

  > .header {
    display: flex;
    border-bottom: 1.53px solid #b0b0b0;
    padding-bottom: 8px;

    > .item {
      flex: 1;
      font-family: Pretendard;
      font-weight: 500;
      font-size: 11px;
      text-align: center;
    }
  }

  > .total {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-family: Pretendard;
    font-weight: 400;
    font-size: 14px;
    gap: 20px;
    border-top: 1.53px dashed #d9d9d9;
    padding-top: 12px;
    margin-top: 25px;

    > span {
      font-family: Pretendard;
      font-weight: 600;
      font-size: 20px;
    }
  }
`;

export const MileageBuyListBody = styled.div`
  width: 100%;
  height: 52px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 8px;
  margin-bottom: 15px;

  > .item-wrapper {
    display: flex;

    > .item {
      flex: 1;
      font-family: Pretendard;
      font-weight: 500;
      font-size: 11px;
      text-align: center;

      &.price {
        display: flex;
        gap: 12px;
        align-items: center;
        justify-content: center;

        > img {
          cursor: pointer;
        }
      }
    }
  }
`;
